import { render } from "./StichingCategory.vue?vue&type=template&id=11f7805c"
import script from "./StichingCategory.vue?vue&type=script&lang=js"
export * from "./StichingCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__